import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as o, normalizeClass as l, createElementVNode as n } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconBook",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, i, _, f, a) {
  return d(), o("svg", {
    "aria-label": i.ariaLabel,
    class: l([a.iconSizeClass, "d-icon d-icon--book"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Book",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    n("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.25.5H10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H3.25A1.75 1.75 0 0 1 1.5 9.75v-7.5A1.75 1.75 0 0 1 3.25.5Zm-.53 1.22a.75.75 0 0 1 .53-.22H9.5V8H3.25a1.75 1.75 0 0 0-.75.169V2.25a.75.75 0 0 1 .22-.53ZM2.5 9.75a.75.75 0 0 0 .75.75H9.5V9H3.25a.75.75 0 0 0-.75.75Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, m);
}
const h = /* @__PURE__ */ s(c, [["render", u]]);
export {
  h as default
};
//# sourceMappingURL=book.js.map
